/* eslint-disable import/order */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { StandardStepApi } from 'api';

export const findStandardStep = createAsyncThunk<
  any,
  { id: string },
  { rejectValue: { message: string } }
>('standardStep/findStandardStep', async (params, { rejectWithValue }) => {
  try {
    return await StandardStepApi.find(params.id);
  } catch (error: any) {
    if (!error.response) {
      throw error;
    }

    return rejectWithValue(error.response.data);
  }
});

interface StandardStepState {}

const initialState: StandardStepState = {};

const standardStepSlice = createSlice({
  name: 'standardStep',
  initialState,
  reducers: {},
  // extraReducers: builder => {},
});

const { reducer: standardStepReducer } = standardStepSlice;

export default standardStepReducer;
